import JobWorkerOfferContactDeclinedReason from "@/models/JobWorkerOffers/JobWorkerOfferContactDeclinedReason";

export default class AnonJobWorkerOfferContactConfirmationReply 
{ 
	confirmed = false;
	declinedReason: JobWorkerOfferContactDeclinedReason = JobWorkerOfferContactDeclinedReason.Undefined;
}